// ================  Popup start ============

function setupPopupClose(popup) {
	const closeButtons = popup.querySelectorAll(".close_popup");
	closeButtons.forEach(btn => btn.addEventListener("click", () => popup.remove()));
	popup.addEventListener("click", (e) => {
		if (e.target.classList.contains("blur_background")) popup.remove();
	});
}

function openLoadingPopup() {
  const showPopup = true;
  if (!showPopup) return;

  const randomIcon = Math.floor(Math.random() * 4) + 1;
  const loadingHTML = `
  <div class="custom_popup blur_background">
    <div class="w-600 rating_popup">
      <button class="close_icon close_popup">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x text-bm-accent/60 group-hover:text-bm-accent transition-colors duration-300"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>
      </button>
      <div class="popup_row">
        <div class="heading_row">
          <div class="icon_row">
            <div class="line"></div>
            <img alt="" src="https://cdn.shopify.com/s/files/1/0926/9510/1767/files/icon-${randomIcon}.png?v=1761714661">
            <div class="line"></div>
          </div>
          <h3 class="popup_heading">System Alert</h3>
        </div>
        <div class="content_row">
          <p>System initialised. Bootstrap code acquired.</p>
        </div>
        <div class="button_row">
          <button class="button button-secondary-outline close_popup">VERIFY</button>
        </div>
        <div class="popup_footer">
          <div class="circle_box animate-pulse"></div>
          <span>GLITCH DETECTED</span>
          <div class="circle_box animate-pulse"></div>
        </div>
      </div>
    </div>
  </div>`;

  document.body.insertAdjacentHTML("beforeend", loadingHTML);
  const popup = document.querySelector(".custom_popup");
  setupPopupClose(popup);
}

window.addEventListener("load", () => {
	document.addEventListener("click", (e) => {
		if (e.target.closest(".discover-popup")) {
			openDiscoverPopup();
		}

	    if (e.target.closest(".copy-arrow")) {
            openTrackingPopup();
        }

		 if (e.target.closest(".sorting_popup")) {
            openSortingPopup();
        }
		
	});
});


function runLoader() {
  const loadingHTML = `
  <div class="custom_loading fixed inset-0 z-[10000] bg-bm-rich-black flex items-center justify-center overflow-hidden">
     <div class="absolute inset-0 scanlines opacity-20 pointer-events-none"></div>
     <div class="absolute inset-0 grain pointer-events-none"></div>
     <div class="relative w-full max-w-2xl px-8">
         <div class="flex items-center justify-between mb-12 border-b border-bm-accent/20 pb-4">
           <div class="flex items-center gap-3">
              <div class="w-3 h-3 bg-bm-accent rounded-full animate-pulse shadow-[0_0_10px_#A4CAEC]"></div>
              <span class="font-mono text-[16px] tracking-[0.2em] uppercase text-bm-accent">SURVEILLANCE ACTIVE</span>
           </div>
           <span class="current_time font-mono text-[16px] text-bm-gray/60">--:--:--</span>
        </div>
        <div class="relative mb-16 h-32 overflow-hidden">
          <div class="absolute inset-0 flex items-center justify-center">
            <div class="w-full h-[2px] bg-gradient-to-r from-transparent via-bm-accent to-transparent animate-scan opacity-70"></div>
          </div>
          <div class="absolute top-0 left-0 w-12 h-12 border-t-2 border-l-2 border-bm-accent/40"></div>
          <div class="absolute top-0 right-0 w-12 h-12 border-t-2 border-r-2 border-bm-accent/40"></div>
          <div class="absolute bottom-0 left-0 w-12 h-12 border-b-2 border-l-2 border-bm-accent/40"></div>
          <div class="absolute bottom-0 right-0 w-12 h-12 border-b-2 border-r-2 border-bm-accent/40"></div>
          <div class="absolute inset-0 flex items-center justify-center">
            <div class="relative">
              <div class="w-24 h-24 border-2 border-bm-accent rounded-full animate-pulse"></div>
              <div class="absolute inset-0 flex items-center justify-center">
                <div class="w-16 h-16 border border-bm-accent/40 rounded-full"></div>
              </div>
              <div class="absolute inset-0 flex items-center justify-center">
                <div class="w-8 h-8 bg-bm-accent/20 rounded-full"></div>
              </div>
            </div>
          </div>
          <div class="absolute inset-0 opacity-20" style="background-image: repeating-linear-gradient(0deg, transparent, transparent 10px, rgba(164, 202, 236, 0.1) 10px, rgba(164, 202, 236, 0.1) 11px), repeating-linear-gradient(90deg, transparent, transparent 10px, rgba(164, 202, 236, 0.1) 10px, rgba(164, 202, 236, 0.1) 11px);"></div>
        </div>
        <div class="analyze_content space-y-2 mb-12 min-h-[120px]">
           <div class="analyze_text font-mono text-[16px] tracking-[0.1em] uppercase flex items-center gap-3 text-bm-gray/50"><span class="text-bm-accent/60">&gt;</span><span>INITIALISING BLACK MIRROR PROTOCOL</span></div>
           <div class="analyze_text font-mono text-[16px] tracking-[0.1em] uppercase flex items-center gap-3 text-bm-gray/50"><span class="text-bm-accent/60">&gt;</span><span>LOADING CONSCIOUSNESS MATRIX</span></div>
           <div class="analyze_text font-mono text-[16px] tracking-[0.1em] uppercase flex items-center gap-3 text-bm-gray/50"><span class="text-bm-accent/60">&gt;</span><span>CALIBRATING SURVEILLANCE ARRAY</span></div>
           <div class="analyze_text font-mono text-[16px] tracking-[0.1em] uppercase flex items-center gap-3 text-bm-gray/50"><span class="text-bm-accent/60">&gt;</span><span>SCANNING BIOMETRIC DATA</span></div>
           <div class="analyze_text font-mono text-[16px] tracking-[0.1em] uppercase flex items-center gap-3 text-bm-gray/50"><span class="text-bm-accent/60">&gt;</span><span>ESTABLISHING NEURAL LINK</span></div>
           <div class="analyze_text font-mono text-[16px] tracking-[0.1em] uppercase flex items-center gap-3 text-bm-gray/50"><span class="text-bm-accent/60">&gt;</span><span>SYNCHRONISING REALITY LAYER</span></div>
           <div class="analyze_text font-mono text-[16px] tracking-[0.1em] uppercase flex items-center gap-3 text-bm-gray/50"><span class="text-bm-accent/60">&gt;</span><span>ACTIVATING SOCIAL CREDIT SYSTEM</span></div>
           <div class="analyze_text font-mono text-[16px] tracking-[0.1em] uppercase flex items-center gap-3 text-bm-gray/50"><span class="text-bm-accent/60">&gt;</span><span>UPLOADING MEMORY FRAGMENTS</span></div>
           <div class="analyze_text font-mono text-[16px] tracking-[0.1em] uppercase flex items-center gap-3 text-bm-gray/50"><span class="text-bm-accent/60">&gt;</span><span>SYSTEM READY - CODE: BOOTSTRAP</span></div>
        </div>
        <div class="space-y-3">
           <div class="flex items-center justify-between text-[16px] font-mono">
             <span class="text-bm-gray/60 tracking-[0.15em] uppercase">Loading</span>
             <span class="text-bm-accent tracking-wider">0%</span>
           </div>
           <div class="relative h-1 bg-bm-dark border border-bm-gray/20 overflow-hidden">
              <div class="progress_bar_loading absolute inset-y-0 left-0 bg-gradient-to-r from-bm-blue via-bm-accent to-bm-accent transition-all duration-100 ease-out shadow-[0_0_10px_#A4CAEC]" style="width:0%;"></div>
              <div class="absolute inset-0 opacity-50">
                <div class="w-1 h-full bg-white/80 animate-scan-vertical shadow-[0_0_5px_white]"></div>
              </div>
            </div>
           <div class="flex items-center justify-between text-[16px] font-mono text-bm-gray/40">
             <span>PROTOCOL v4.2.1</span>
             <span class="memory_counter">MEMORY: <span class="memory_number">0%</span></span>
             <span class="cpu_counter">CPU: <span class="cpu_number">0%</span></span>
           </div>
        </div>
        <div class="mt-12 pt-8 border-t border-bm-gray/10">
          <p class="text-center font-mono text-[16px] text-bm-gray/40 tracking-[0.15em] uppercase">Your experience is being monitored</p>
        </div>
     </div>
     <div class="absolute top-4 left-4 w-8 h-8 border-t border-l border-bm-accent/30"></div>
     <div class="absolute top-4 right-4 w-8 h-8 border-t border-r border-bm-accent/30"></div>
     <div class="absolute bottom-4 left-4 w-8 h-8 border-b border-l border-bm-accent/30"></div>
     <div class="absolute bottom-4 right-4 w-8 h-8 border-b border-r border-bm-accent/30"></div>
     <div class="absolute bottom-4 left-1/2 -translate-x-1/2 font-mono text-[10px] text-bm-gray/10 tracking-[0.3em]">ACCESS_CODE: BOOTSTRAP</div>
  </div>`;

  const appendLoader = () => {
    if (document.body) {
      document.body.insertAdjacentHTML("beforeend", loadingHTML);
      startAnimation();
    } else {
      requestAnimationFrame(appendLoader);
    }
  };

  appendLoader();

  function updateTime() {
    const el = document.querySelector(".current_time");
    if (!el) return;
    const now = new Date().toLocaleTimeString("en-IN", {
      timeZone: "Asia/Kolkata",
      hour12: false,
    });
    el.textContent = now;
  }

  function startAnimation() {
    const loader = document.querySelector(".custom_loading");
    const lines = loader.querySelectorAll(".analyze_text");
    const loadingEl = loader.querySelector(".tracking-wider");
    const memoryEl = loader.querySelector(".memory_number");
    const cpuEl = loader.querySelector(".cpu_number");
    const progressBar = loader.querySelector(".progress_bar_loading");

    setInterval(updateTime, 1000);
    updateTime();

    lines.forEach(line => (line.style.display = "none"));

    const dotsHTML = `
      <div class="ml-auto flex gap-1 dots">
        <div class="w-1 h-1 bg-bm-accent rounded-full animate-pulse"></div>
        <div class="w-1 h-1 bg-bm-accent rounded-full animate-pulse" style="animation-delay: 0.2s;"></div>
        <div class="w-1 h-1 bg-bm-accent rounded-full animate-pulse" style="animation-delay: 0.4s;"></div>
      </div>`;

    let current = 0;
    function revealNext() {
      lines.forEach(line => {
        line.classList.remove("text-bm-accent");
        line.classList.add("text-bm-gray/50");
        const dots = line.querySelector(".dots");
        if (dots) dots.remove();
      });

      if (current < lines.length) {
        const active = lines[current];
        active.style.display = "flex";
        active.classList.add("text-bm-accent");
        active.insertAdjacentHTML("beforeend", dotsHTML);
        current++;
        setTimeout(revealNext, 700);
      }
    }
    revealNext();

    let loading = 0;
    const interval = setInterval(() => {
      if (loading < 100) {
        loading++;
        const memory = Math.max(0, Math.min(100, loading - 8));
        const cpu = Math.max(0, Math.min(100, memory - 17));

        loadingEl.textContent = `${loading}%`;
        memoryEl.textContent = `${memory}%`;
        cpuEl.textContent = `${cpu}%`;
        progressBar.style.width = `${loading}%`;
      } else {
        clearInterval(interval);
        setTimeout(() => {
          loader.remove();
          localStorage.setItem("firstVisitDone", "true");
          openLoadingPopup();
        }, 1000);
      }
    }, 80);
  }
}

if (!localStorage.getItem("firstVisitDone")) {
  runLoader(); // Immediately execution
}

document.addEventListener("DOMContentLoaded", () => {
  const timeEl = document.querySelector(".current_time");
  const analyzeLines = document.querySelectorAll(".analyze_content > div");
  const progressEl = document.querySelector(".tracking-wider");
  const memoryEl = document.querySelector(".memory_number");
  const cpuEl = document.querySelector(".cpu_number");
  const dotsHTML = `
    <div class="ml-auto flex gap-1 dots">
      <div class="w-1 h-1 bg-bm-accent rounded-full animate-pulse"></div>
      <div class="w-1 h-1 bg-bm-accent rounded-full animate-pulse" style="animation-delay: 0.2s;"></div>
      <div class="w-1 h-1 bg-bm-accent rounded-full animate-pulse" style="animation-delay: 0.4s;"></div>
    </div>
  `;

  function updateTime() {
    const now = new Date().toLocaleTimeString("en-IN", {
      timeZone: "Asia/Kolkata",
      hour12: false,
    });
    if (timeEl) timeEl.textContent = now;
  }
  updateTime();
  setInterval(updateTime, 1000);

  let currentIndex = 0;
  let dots;
  function nextLine() {
    analyzeLines.forEach(line => {
      line.classList.remove("text-bm-accent");
      line.classList.add("text-bm-gray/50");
      const existingDots = line.querySelector(".dots");
      if (existingDots) existingDots.remove();
    });

    const active = analyzeLines[currentIndex];
    if (active) {
      active.classList.remove("text-bm-gray/50");
      active.classList.add("text-bm-accent");
      active.insertAdjacentHTML("beforeend", dotsHTML);
      dots = active.querySelector(".dots");
    }

    currentIndex++;
    if (currentIndex < analyzeLines.length) {
      setTimeout(nextLine, 700);
    }
  }
  nextLine();

  let loading = 0;
  const loadingText = document.querySelector(".tracking-wider");
  const memoryText = document.querySelector(".memory_number");
  const cpuText = document.querySelector(".cpu_number");

  const progressBar = document.querySelector(".progress-bar-inner");

  const loadingInterval = setInterval(() => {
    if (loading < 100) {
      loading += 1;
      let memory = Math.floor(loading - 8);
      let cpu = Math.floor(memory - 17);
      memory = Math.max(0, Math.min(memory, 100));
      cpu = Math.max(0, Math.min(cpu, 100));

      if (loadingText) loadingText.textContent = `${loading}%`;
      if (memoryText) memoryText.textContent = `${memory}%`;
      if (cpuText) cpuText.textContent = `${cpu}%`;

      const bar = document.querySelector(".progress-bar-inner");
      if (bar) bar.style.width = `${loading}%`;
    } else {
      clearInterval(loadingInterval);
    }
  }, 80);
});

// ================  Popup End ============



